function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMada(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.609,
    height: 31.976,
    viewBox: "0 0 40.609 31.976",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1",
    transform: "translate(0 18.453)",
    style: {
      fill: "#84b740"
    },
    d: "M0 0h40.609v13.523H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2",
    style: {
      fill: "#259bd6"
    },
    d: "M0 0h40.609v13.535H0z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMada);
export default __webpack_public_path__ + "static/media/mada.ff75076ba87d1a5fbb255d6af392c414.svg";
export { ForwardRef as ReactComponent };